import { render } from "./EditBoProfile.vue?vue&type=template&id=6cc214e9&scoped=true&ts=true"
import script from "./EditBoProfile.vue?vue&type=script&lang=ts"
export * from "./EditBoProfile.vue?vue&type=script&lang=ts"

import "./EditBoProfile.vue?vue&type=style&index=0&id=6cc214e9&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc214e9"]])

export default __exports__